/* eslint-disable-next-line */
type SpecificationTextProps = {
  text: string;
};

export function SpecificationText(props: SpecificationTextProps) {
  const { text } = props;
  return <p className="text-subtitle leading-6">{text}</p>;
}

export default SpecificationText;
